export const ROUTES = {
    QUESTIONS: '/v2/questions',
    SESSIONS: '/v2/sessions',
    ANSWERS: '/v2/answers',
    SUBMIT_EMAIL: '/v1/42app/users',
    USER_REPORT: (sessionId: string) => `/v2/sessions/${sessionId}/report`,
    SESSIONS_ANSWERS: (sessionId: string) => `/v2/sessions/${sessionId}`,
    GET_SESSIONS_ID: (uniqueId: string) => `/v1/ids/${uniqueId}`
};
